import { defineComponent as v, computed as p, openBlock as t, createBlock as s, withCtx as x, createElementVNode as r, normalizeClass as i, unref as c, createElementBlock as n, toDisplayString as l, createCommentVNode as u, Fragment as h, renderList as k, normalizeStyle as _, resolveDynamicComponent as w } from "vue";
import { useLandingAnimation as C } from "./index127.js";
import z from "./index116.js";
import V from "./index60.js";
const $ = {
  key: 0,
  class: "text-xs font-semibold uppercase tracking-widest",
  style: { color: "var(--landing-primary)" }
}, B = {
  class: "mt-3 text-3xl font-bold md:text-4xl lg:text-5xl",
  style: { color: "var(--landing-dark)" }
}, D = {
  key: 0,
  class: "mb-4 flex h-12 w-12 items-center justify-center rounded-xl",
  style: { background: "var(--landing-features-icon-bg)" }
}, L = {
  key: 2,
  class: "text-2xl leading-none"
}, N = {
  class: "mb-2 text-lg font-semibold",
  style: { color: "var(--landing-dark)" }
}, S = {
  class: "text-sm leading-relaxed",
  style: { color: "var(--landing-features-desc)" }
}, M = /* @__PURE__ */ v({
  __name: "LandingFeatures",
  props: {
    overline: {},
    title: {},
    items: {},
    columns: { default: 3 },
    bg: { default: "light" },
    primary: { default: "var(--base-colors-primary-primary800)" },
    id: {}
  },
  setup(a) {
    const g = {
      2: "md:grid-cols-2",
      3: "md:grid-cols-2 lg:grid-cols-3",
      4: "md:grid-cols-2 lg:grid-cols-4"
    }, { el: m, isVisible: o } = C(), y = p(() => ({
      "--landing-features-card-bg": "var(--base-colors-neutral-neutral000)",
      "--landing-features-border": "var(--base-colors-neutral-neutral200)",
      "--landing-features-icon-bg": "var(--base-colors-neutral-neutral050)",
      "--landing-features-desc": "var(--base-colors-neutral-neutral500)"
    }));
    function f(d) {
      return /^[a-z0-9-]+$/.test(d);
    }
    return (d, E) => (t(), s(z, {
      bg: a.bg,
      id: a.id,
      primary: a.primary
    }, {
      default: x(() => [
        r("div", {
          ref_key: "el",
          ref: m
        }, [
          r("div", {
            class: i(["mb-12 text-center transition-all duration-700", c(o) ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"])
          }, [
            a.overline ? (t(), n("span", $, l(a.overline), 1)) : u("", !0),
            r("h2", B, l(a.title), 1)
          ], 2),
          r("div", {
            class: i(["grid grid-cols-1 gap-6 lg:gap-8", g[a.columns]])
          }, [
            (t(!0), n(h, null, k(a.items, (e, b) => (t(), n("div", {
              key: e.title,
              class: i(["h-full rounded-xl border p-6 shadow transition-all duration-300 ease-in-out hover:-translate-y-1 hover:shadow-lg", c(o) ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"]),
              style: _([
                y.value,
                {
                  transitionDelay: c(o) ? `${b * 80}ms` : "0ms",
                  transition: "opacity 0.7s ease, transform 0.7s ease",
                  borderColor: "var(--landing-features-border)",
                  background: "var(--landing-features-card-bg)"
                }
              ])
            }, [
              e.icon ? (t(), n("div", D, [
                typeof e.icon != "string" ? (t(), s(w(e.icon), {
                  key: 0,
                  class: "h-6 w-6",
                  style: { color: "var(--landing-dark)" }
                })) : typeof e.icon == "string" && f(e.icon) ? (t(), s(V, {
                  key: 1,
                  name: e.icon,
                  size: "md",
                  color: "var(--landing-dark)"
                }, null, 8, ["name"])) : (t(), n("span", L, l(e.icon), 1))
              ])) : u("", !0),
              r("h3", N, l(e.title), 1),
              r("p", S, l(e.description), 1)
            ], 6))), 128))
          ], 2)
        ], 512)
      ]),
      _: 1
    }, 8, ["bg", "id", "primary"]));
  }
});
export {
  M as default
};
